import { compact, isEmpty } from 'lodash';

import { PITagsApi, PITagsEditorState } from '../typings/piTags';

export function mapPiTagsToApi(piTagsEditor: PITagsEditorState = {}): PITagsApi {
    const result: PITagsApi = {
        pageGroupTags: null,
        targetTags: null
    };

    if (isEmpty(piTagsEditor)) {
        return result;
    }

    result.pageGroupTags = piTagsEditor.pageGroupTags
        ? compact(piTagsEditor.pageGroupTags.replace(/\s/g, '').split(','))
        : [];

    result.targetTags = piTagsEditor.targetTags ? compact(piTagsEditor.targetTags.replace(/\s/g, '').split(',')) : [];

    return result;
}

export function mapPiTagsFromApi(piTags: PITagsApi): PITagsEditorState {
    const result: PITagsEditorState = {};

    if (piTags.pageGroupTags) {
        result.pageGroupTags = piTags.pageGroupTags.join(', ');
    }

    if (piTags.targetTags) {
        result.targetTags = piTags.targetTags.join(', ');
    }

    return result;
}
